import React, { ReactElement } from 'react';
import classNames from 'classnames';
import classes from './classes.module.scss';
import { isKA } from '../../../common/config/utils';
import { SvgIcon } from '../../../common/sprites';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const OrderTypes = {
  'live-chat': 'live-chat',
  'video-call': 'video-call',
  'voice-call': 'voice-call'
};

const renderOrderIcon = (type: string) => {
  switch (type) {
    case 'live-chat':
      return <SvgIcon className={ classes.orderCellIcon } id="live_chat" />;
    case 'video-call':
      return <SvgIcon className={ classes.orderCellIcon } id="video_call" />;
    case 'voice-call':
      return <SvgIcon className={ classes.orderCellIcon } id="voice_call" />;
    default:
      return null;
  }
};

const getCellContainerClass = (type: string) => {
  if (!isKA()) return classNames(classes.orderCellContainer, classes.borderDefault);
  switch (type) {
    case 'live-chat':
      return classNames(classes.orderCellContainer, classes.kaBorderChat);
    case 'voice-call':
      return classNames(classes.orderCellContainer, classes.kaBorderVoice);
    default:
      return null;
  }
};

interface MyOrdersOrderCellProps {
  type: keyof typeof OrderTypes,
  orderSubject?: string,
  orderDescription?: string,
  labels?: Array<ReactElement>,
  advisorId?: string,
  activityId?: number,
}

const MyOrdersOrderCell: React.FC<MyOrdersOrderCellProps> = ({
  type = 'live-chat',
  orderSubject,
  orderDescription = '',
  labels = []
}) => {
  const renderLabel = () => (
    <div className={ classes.labelsHolderContainer }>
      {labels.map((label, index) => (
        <div className={ classes.orderCellLabelContainer } key={ index }>
          {label}
        </div>
      ))}
    </div>
  );

  const renderOrderSubject = () => (
    <div className={ classes.orderCellSubjectContainer }>
      <div className={ classes.orderSubjectName }>
        {orderSubject}
      </div>
    </div>
  );

  const renderOrderTitle = () => (
    <div className={ classes.orderCellTitleContainer }>
      {renderOrderIcon(type)}
      {renderOrderSubject()}
    </div>
  );

  const renderOrderDescription = () => (
    <div className={ classes.orderDescriptionContainer }>
      {orderDescription.length > 0 ? <SvgIcon className={ classes.orderDescriptionIcon } id="clock" /> : null}
      <div className={ classes.orderDescription }>
        {orderDescription}
      </div>
    </div>
  );

  const renderMyOrdersAdvisorCell = () => (
    <div className={ getCellContainerClass(type) }>
      <div className={ classes.orderCellContentContainer }>
        <div className={ classes.orderTitleLabelsContainer }>
          {renderOrderTitle()}
          {renderLabel()}
        </div>
      </div>
      <div className={ classes.orderRightDataContainer }>
        <div className={ classes.orderDataContainer }>
          {renderOrderDescription()}
        </div>
        <div className={ classes.rightArrowContainer }>
          <SvgIcon id="right_arrow" className={ classes.rightArrowIcon } size={ 24 } />
        </div>
      </div>
    </div>
  );

  return renderMyOrdersAdvisorCell();
};

export default MyOrdersOrderCell;
